export default function sold(){
    return(
        <div>
            
        </div>
    )
}